/* eslint-disable */
import * as React from "react";
import { useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Slider from "@mui/material/Slider";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";

import prototype from "assets/images/new-device.jpg";

import foodToFeedbackMapping from "../../config/foodToFeedbackMapping.json";
import foodItemIdToNameMapping from "../../config/foodItemIdToNameMapping.json";

// Utility function to get feedback dimensions for a food item
const getFeedbackDimensions = (foodItem) => {
  const category = foodToFeedbackMapping.food_item_mapping[foodItem];
  const feedbackDimensions = foodToFeedbackMapping.feedback_dimensions[category];
  return feedbackDimensions || [];
};

const style = {
  display: "grid",
  gridTemplateColumns: "1fr",
  justifyItems: "center",
  alignItems: "center",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "65%",
  height: "60%",
  bgcolor: "background.paper",
  border: "1px solid #B69552",
  boxShadow: 24,
  p: 4,
};

const sliderMarks = [
  { value: 1, label: "A lot less" },
  { value: 2, label: "Slightly less" },
  { value: 3, label: "Keep the same" },
  { value: 4, label: "Slightly more" },
  { value: 5, label: "A lot more" },
];

const sliderMarksMobile = [
  { value: 1, label: "--" },
  { value: 2, label: "-" },
  { value: 3, label: "." },
  { value: 4, label: "+" },
  { value: 5, label: "++" },
];

const sliderMarksOverallSatsifaction = [
  { value: 1, label: "Very Dissatisfied" },
  { value: 2, label: "Dissatisfied" },
  { value: 3, label: "Perfect" },
  { value: 4, label: "Satisfied" },
  { value: 5, label: "Very Satisfied" },
];

const sliderMarksOverallSatisfactionMobile = [
  { value: 1, label: "☹️" },
  { value: 2, label: "😞" },
  { value: 3, label: "😐" },
  { value: 4, label: "🙂" },
  { value: 5, label: "😀" },
];

const sliderMarksTexture = {
  moistness: [
    { value: 1, label: "Too dry" },
    { value: 2, label: "Slightly dry" },
    { value: 3, label: "Perfect" },
    { value: 4, label: "Slightly moist" },
    { value: 5, label: "Too moist" },
  ],
  tenderness: [
    { value: 1, label: "Too tough" },
    { value: 2, label: "Slightly tough" },
    { value: 3, label: "Perfect" },
    { value: 4, label: "Slightly tender" },
    { value: 5, label: "Too tender" },
  ],
  crispiness: [
    { value: 1, label: "Too soft" },
    { value: 2, label: "Slightly soft" },
    { value: 3, label: "Perfect" },
    { value: 4, label: "Slightly crispy" },
    { value: 5, label: "Too crispy" },
  ],
  juiciness: [
    { value: 1, label: "Extremely dry" },
    { value: 2, label: "Slightly dry" },
    { value: 3, label: "Perfect" },
    { value: 4, label: "Slightly juicy" },
    { value: 5, label: "Too juicy" },
  ],
};

const sliderMarksTextureMobile = {
  moistness: [
    { value: 1, label: "🏜️" },
    { value: 2, label: "🌵" },
    { value: 3, label: "👌" },
    { value: 4, label: "💧" },
    { value: 5, label: "💦" },
  ],
  tenderness: [
    { value: 1, label: "🪨" },
    { value: 2, label: "🥩" },
    { value: 3, label: "👌" },
    { value: 4, label: "🧈" },
    { value: 5, label: "☁️" },
  ],
  crispiness: [
    { value: 1, label: "🍞" },
    { value: 2, label: "🥖" },
    { value: 3, label: "👌" },
    { value: 4, label: "🥠" },
    { value: 5, label: "💥" },
  ],
  juiciness: [
    { value: 1, label: "🏜️" },
    { value: 2, label: "🌵" },
    { value: 3, label: "👌" },
    { value: 4, label: "💧" },
    { value: 5, label: "💦" },
  ],
};

/***************** START OF COMPONENT ************************/

export default function BasicModal2(props) {
  const [feedbackValues, setFeedbackValues] = React.useState({});
  const [currentDimension, setCurrentDimension] = React.useState(0);

  useEffect(() => {
    setFeedbackValues(initializeFeedbackValues(feedbackDimensions));
    setCurrentDimension(0);
  }, [props.data.foodItemId]);

  const initializeFeedbackValues = (dimensions) => {
    return dimensions.reduce((acc, dimension) => {
      acc[dimension] = 3; // Set default value to 3
      return acc;
    }, {});
  };

  const feedbackDimensions = getFeedbackDimensions(foodItemIdToNameMapping[props.data.foodItemId]);

  const moveToNextDimension = () => {
    if (currentDimension < feedbackDimensions.length - 1) {
      setCurrentDimension(currentDimension + 1);
    } else {
      submitFeedback();
    }
  };

  const getSliderMarks = (dimension) => {
    if (dimension === "overall_satisfaction") {
      return window.innerWidth < 1500
        ? sliderMarksOverallSatisfactionMobile
        : sliderMarksOverallSatsifaction;
    } else if (["moistness", "tenderness", "crispiness", "juiciness"].includes(dimension)) {
      return window.innerWidth < 1500
        ? sliderMarksTextureMobile[dimension]
        : sliderMarksTexture[dimension];
    } else {
      return window.innerWidth < 1500 ? sliderMarksMobile : sliderMarks;
    }
  };

  const handleSliderChange = (dimension, value) => {
    setFeedbackValues((prev) => {
      const newValues = { ...prev, [dimension]: value };
      // console.log("Updated feedback values:", newValues); // Log the updated values
      return newValues;
    });
  };

  const submitFeedback = async () => {
    const feedbackSchemaData = {
      doneness: feedbackValues.doneness,
      overallSatisfaction: feedbackValues.overall_satisfaction,
      texture: {
        crispiness: feedbackValues.crispiness,
        tenderness: feedbackValues.tenderness,
        juiciness: feedbackValues.juiciness,
        moistness: feedbackValues.moistness_interior,
      },
      appearance: {
        evenness: feedbackValues.evenness_of_cooking,
      },
    };

    const data = {
      sub: props.data.sub,
      foodItemId: props.data.foodItemId,
      cookingSessionId: props.data.sessionId,
      timestamp: new Date().toISOString(),
      ...feedbackSchemaData, // Include the feedback values in the data object
    };

    try {
      const response = await fetch(
        `https://4dq7z5seh9.execute-api.us-east-1.amazonaws.com/development/feedbackSession/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );
      if (response.ok) {
        console.log("Feedback submitted successfully");
        props.handleClose();
      }
    } catch (error) {
      console.log(error);
    } finally {
      // Reset the feedback values and current dimension
      setFeedbackValues({});
      setCurrentDimension(0);

      props.handleClose();
    }
  };

  const getCurrentDimensionPrompt = (foodName) => {
    const dimension = feedbackDimensions[currentDimension];
    switch (dimension) {
      case "doneness":
        return `Your ${foodName} was cooked to MEDIUM. Do you want it more or less done next time?`;
      case "crispiness":
        return `Your ${foodName} were cooked to MODERATELY CRISPY. Do you want them more or less crispy next time?`;
      // TODO: add more cases for other dimensions
      default:
        return `How would you rate the ${dimension.replace("_", " ")} of your ${foodName}?`;
    }
  };

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-device-add"
      aria-describedby="modal-device-add-description"
    >
      <Box sx={style}>
        {props.data.feedback ? (
          <MDTypography variant="h6" component="h2">
            Thank you for your feedback
          </MDTypography>
        ) : (
          <>
            <MDTypography variant="h6" component="h2">
              {getCurrentDimensionPrompt(foodItemIdToNameMapping[props.data.foodItemId])}
            </MDTypography>
            <Slider
              aria-label={feedbackDimensions[currentDimension]}
              value={feedbackValues[feedbackDimensions[currentDimension]] || 3}
              getAriaValueText={(value) => `${value}`}
              step={1}
              valueLabelDisplay="auto"
              marks={getSliderMarks(feedbackDimensions[currentDimension])}
              min={1}
              max={5}
              onChange={(e, val) => handleSliderChange(feedbackDimensions[currentDimension], val)}
              sx={{
                width: "80%", // Adjust this value to make the slider narrower,
                "& .MuiSlider-markLabel": {
                  fontSize: "0.75rem", // Adjust this value to make the text smaller
                },
                "& .MuiSlider-mark": {
                  height: 8, // Adjust this to reduce vertical space between marks and labels
                },
                "& .MuiSlider-rail": {
                  opacity: 0.5,
                },
                "& .MuiSlider-valueLabel": {
                  fontSize: "0.75rem", // Make the value label smaller too
                },
                marginBottom: 2, // Add some margin at the bottom of the slider
              }}
            />
            <MDButton variant="gradient" color="dark" onClick={moveToNextDimension}>
              {currentDimension < feedbackDimensions.length - 1 ? (
                <Icon sx={{ fontWeight: "bold" }} fontSize="small">
                  arrow_forward
                </Icon>
              ) : (
                "Submit feedback"
              )}
            </MDButton>
          </>
        )}
      </Box>
    </Modal>
  );
}
